import db from "../db/database";
import { BOLETA, FACTURA, tipoSunatDelDocumento } from "../utils/tipoSunatDelDocumento";

// Perú: si una nota de crédito corrige una factura ("01") o una boleta ("03").
// Lo usan el envío a Business Central (`SUNAT_Document_Ref`, invoiceSyncService)
// y el guardado de la nota (`Applies_to_SUNAT_Document`, InvoiceForm).
//
// Había dos funciones para esto: ésta, en invoiceService, y
// `tipoDelDocumentoQueCorrige`, en invoiceSyncService, escritas a la vez el
// 27/10/2026 en dos ramas. Al fusionarlas, el envío se quedó con una y las
// pruebas de la otra dejaron de pasar. Queda una sola, con lo bueno de las dos:
// lo que la nota ya trae guardado, el original buscado por su número sin
// confundirlo con otra nota de crédito del mismo número, y el tipo del original
// leído de lo que diga --nunca de la serie, salvo como último respaldo--.
//
// Vive aparte para que invoiceService e invoiceSyncService la compartan sin
// importarse entre sí.

/** El documento de venta que lleva ese número, sin contar notas de crédito. */
const buscarElOriginal = async (numero) => {
  for (const campo of ["No", "Pre_Assigned_No"]) {
    const candidatos = await db.invoices.where(campo).equals(numero).toArray();
    const original = candidatos.find((doc) => !doc.deleted && doc.Document_Type !== "Credit Memo");
    if (original) return original;
  }
  return null;
};

/**
 * @param {object} notaDeCredito La nota, con `Applies_to_Doc_No`.
 * @returns {Promise<"01"|"03"|null>} El tipo del documento que corrige, o null si
 *   no hay forma de saberlo.
 */
export const tipoSunatDeLaReferencia = async (notaDeCredito) => {
  const guardado = String(notaDeCredito?.Applies_to_SUNAT_Document ?? "").trim();
  if (guardado === FACTURA || guardado === BOLETA) return guardado;

  const numero = String(notaDeCredito?.Applies_to_Doc_No ?? "").trim();
  if (!numero) return null;

  try {
    const original = await buscarElOriginal(numero);
    return tipoSunatDelDocumento(original || { No: numero }) ?? tipoSunatDelDocumento({ No: numero });
  } catch {
    return tipoSunatDelDocumento({ No: numero });
  }
};
